export default `
query GetServiceProvider($serviceProviderId: ID!,) {
  getServiceProvider(serviceProviderId: $serviceProviderId) {
    fullName
    serviceProviderId
    logoPath
  }
}
`;